import MonsterCharacter from "./MonsterCharacter";
import MonsterCharacterCache from "./MonsterCharacterCache";
import GridTile from "../grid/GridTile";
import MonsterDescription from "../monster/MonsterDescription";
import MonsterSpritesheet from "../sprite/MonsterSpritesheet";
import CharacterBrains from "./brain/CharacterBrains";
import GameModel from "../../GameModel";

export default class CharacterCreator extends GameModel {
    /**
     * @param {MonsterSpritesheet} monsterSpritesheet 
     * @param {CharacterBrains} characterBrains
     */
    constructor(monsterSpritesheet, characterBrains) {
        super();

        /**
         * @constant
         * @type {MonsterSpritesheet}
         */
        this.monsterSpritesheet = monsterSpritesheet;

        /**
         * @constant
         * @type {CharacterBrains}
         */
        this.characterBrains = characterBrains;

        /**
         * @constant
         * @type {MonsterCharacterCache}
         */
        this.monsterCharacterCache = new MonsterCharacterCache();

        /**
         * @constant
         * @type {number}
         */
        this.baseMonsterDamage = 5;
        /**
         * @constant
         * @type {number}
         */
        this.monsterDamageIncrease = 0.6;
        /**
         * @constant
         * @type {number}
         */
        this.monsterDamageHundredFactor = 0.1;

        /**
         * @constant
         * @type {number}
         */
        this.baseMonsterHealth = 5;
        /**
         * @constant
         * @type {number}
         */
        this.monsterHealthIncrease = 0.6;
        /**
         * @constant
         * @type {number}
         */
        this.monsterHealthHundredFactor = 0.1;

    }

    /**
     * @param {MonsterDescription} monsterDescription 
     * @param {GridTile} tile 
     * @returns {MonsterCharacter}
     */
    createMonsterAtTile(monsterDescription, tile) {

        const monster = this.createMonsterCharacter(monsterDescription);

        const origin = tile.origin;
        monster.position.setTileAndOriginPosition(tile, origin.x, origin.y);

        return monster;
    }

    /**
     * @private
     * @param {MonsterDescription} monsterDescription 
     * @returns {MonsterCharacter}
     */
    createMonsterCharacter(monsterDescription) {
        const sprite = this.monsterSpritesheet.getSprite(monsterDescription.spriteName);
        if (sprite == null) {
            console.log("CharacterCreator.createMonsterCharacter() Failed to find monster sprite: " + monsterDescription.spriteName);
            return null;
        }

        /////////////////////////////////////////////////////////////////////
        // Brain
        /////////////////////////////////////////////////////////////////////

        const brain = this.characterBrains.getBrainById(monsterDescription.brainId);
        if (!brain) {
            console.log("CharacterCreator.createMonsterCharacter() Failed to find monster brain id: " + monsterDescription.brainId);
            return null;
        }

        /////////////////////////////////////////////////////////////////////
        // Monster Character
        /////////////////////////////////////////////////////////////////////

        /**
         * @type {MonsterCharacter}
         */
        const monster = this.monsterCharacterCache.get();
        monster.set(brain, sprite, monsterDescription);

        return monster;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.monsterCharacterCache.resetCache();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }
}
